import React, { useState, useEffect } from "react";
import SearchInput from "../../ShareElements/SearchInput/SearchInput";
import SearchSelect from "./SharedElements/SearchSelect";
import SimpleFilter from "../../ShareElements/Select/MultiSelect";
import { Config } from "../../../../../Config";
import axios from "axios";
import BookmarkIcon from "../../../../../Assets/Images/bookmark.svg";
import Switch from "../../ShareElements/TextInput/Switch";
import RangeDatepicker from "./SharedElements/RangeDatepicker";
import { formatDate } from "../../../../../Helper_functions";

const ContentHead = (props) => {
  const [Locations, setLocations] = useState([]);
  const [Skills, setSkills] = useState([]);
  const [SelectedSkills, setSelectedSkills] = useState([]);
  const [SelectedStatuses, setSelectedStatuses] = useState([]);
  const [SelectedLocations, setSelectedLocations] = useState([]);
  const [DatepickerIsOpen, setDatepickerIsOpen] = useState(false);
  const [SelectedDate, setSelectedDate] = useState();
  const [MobileFilterIsOpen, setMobileFilterIsOpen] = useState(false);
  const [SelectedFilterCount, setSelectedFilterCount] = useState(0);

  useEffect(() => {
    fetchSkills("");
    fetchCountries();
  }, []);
  const translateText = (LabelId) => {
    var Filter = "label_id";
    var Keyword = LabelId;
    var Label = props.LangData.filter((Obj) => {
      return Obj[Filter] === Keyword;
    });
    return Label[0].label_value;
  };
  const fetchCountries = () => {
    let Req = {
      method: "GET",
      baseURL:
        window._env_.API_URL +
        Config.AuthBaseURL +
        "/api/user-info/wizard/findAllCountries",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        setLocations(Res.data);
      })
      .catch((Err) => {
        console.log(Err);
      });
  };

  const fetchSkills = (NameLike) => {
    let Keyword = NameLike;
    let Req = {
      method: "POST",
      baseURL: window._env_.API_URL + Config.AuthBaseURL + "/api/skill/search",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
        "Content-Type": "application/json",
      },
      data: {
        size: 100,
        start: 0,
        criteria: {
          titleLike: Keyword,
        },
        sorts: [
          {
            direction: "ASC",
            fieldName: "title",
          },
        ],
      },
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        setSkills(Res.data.results);
      })
      .catch((Err) => {
        console.log(Err);
      });
  };

  const updateSkills = (List) => {
    let TitleLike = document.getElementById("search-input").value;

    setSelectedSkills(List);
    var RemainingSkills = [];
    [...Skills].map((SkillItem) => {
      if ([...List].indexOf(SkillItem) === -1) {
        RemainingSkills.push(SkillItem);
      }
    });
    setSkills(RemainingSkills);
    props.SearchByFilters(TitleLike, SelectedStatuses, SelectedLocations, List);
  };

  const displayDatepicker = (DateIsReset) => {
    if (DatepickerIsOpen) {
      let TitleLike = document.getElementById("search-input").value;

      if (DateIsReset) {
        props.SearchByFilters(
          TitleLike,
          SelectedStatuses,
          SelectedLocations,
          SelectedSkills,
          null
        );
      } else {
        props.SearchByFilters(
          TitleLike,
          SelectedStatuses,
          SelectedLocations,
          SelectedSkills,
          SelectedDate
        );
      }
      if (!DateIsReset) {
        setDatepickerIsOpen(false);
      }
      document.getElementById("datepicker-trigger").style.transform = "none";
    } else {
      if (!DateIsReset) {
        setDatepickerIsOpen(true);
      }
      document.getElementById("datepicker-trigger").style.transform =
        "rotate(180deg)";
    }
  };

  const saveSelectedDate = (Start, End) => {
    setSelectedDate({
      start: formatDate(new Date(Start)),
      startTimestamp: Start,
      endTimestamp: End,
      end: formatDate(new Date(End)),
    });
  };

  const handleSearchbyTitle = () => {
    let TitleLike = document.getElementById("search-input").value;

    props.SearchByFilters(
      TitleLike,
      SelectedStatuses,
      SelectedLocations,
      SelectedSkills
    );
  };

  const selectStatus = () => {
    let TitleLike = document.getElementById("search-input").value;

    let Selected = [];
    props.StatusOptions.map((Status) => {
      if (
        document
          .getElementById("icon-" + Status)
          .classList.contains("feather-check-selected")
      ) {
        Selected.push(Status.replace(" ", "_").toUpperCase());
      }
    });
    setSelectedStatuses(Selected);

    props.SearchByFilters(
      TitleLike,
      Selected,
      SelectedLocations,
      SelectedSkills
    );
  };

  const selectLocations = () => {
    let TitleLike = document.getElementById("search-input").value;

    let Selected = [];
    Locations.map((Item) => {
      if (
        document
          .getElementById("icon-" + Item.id)
          .classList.contains("feather-check-selected")
      ) {
        Selected.push(Item.id);
      }
    });
    setSelectedLocations(Selected);

    props.SearchByFilters(
      TitleLike,
      SelectedStatuses,
      Selected,
      SelectedSkills
    );
  };

  const clearSkills = () => {
    let TitleLike = document.getElementById("search-input").value;

    removeSkillsSelectedState();

    setSelectedSkills([]);
    fetchSkills("");

    props.SearchByFilters(TitleLike, SelectedStatuses, SelectedLocations, []);
  };
  const removeSkillsSelectedState = () => {
    Skills.map((Item) => {
      let Id = Item.id;
      if (document.getElementById(Id + "-option") !== null) {
        document.getElementById(Id + "-option").classList.remove("selected");
      }
    });
  };

  const displayMobileFilters = () => {
    setMobileFilterIsOpen(true);
  };

  const clearMobileFilters = () => {
    clearSkills();
    if (document.getElementById("status-clear") !== null) {
      document.getElementById("status-clear").click();
    }
    if (document.getElementById("location-clear") !== null) {
      document.getElementById("location-clear").click();
    }
  };
  const closeMobileFilters = () => {
    let TitleLike = document.getElementById("search-input").value;

    clearMobileFilters();
    props.SearchByFilters(TitleLike, [], [], [], SelectedDate);
    setMobileFilterIsOpen(false);
  };

  const applyMobileFilters = () => {
    updateSelectedFilterCount();
    setMobileFilterIsOpen(false);
  };

  const updateSelectedFilterCount = () => {
    var InitialValue = 0;
    if (SelectedStatuses.length > 0) {
      InitialValue++;
    }
    if (SelectedLocations.length > 0) {
      InitialValue++;
    }
    if (SelectedSkills.length > 0) {
      InitialValue++;
    }
    setSelectedFilterCount(InitialValue);
  };

  return (
    <div className="vacancies-head">
      {window.innerWidth < 450 ? (
        <div
          className="mobile-filters-overlay is-mobile"
          hidden={MobileFilterIsOpen ? false : true}
        >
          <section className="mobile-filters-head">
            <i className="feather-x" onClick={() => closeMobileFilters()}></i>
            <p>{translateText("filters")}</p>
            <span onClick={() => clearMobileFilters()}>
              {translateText("clear")}
            </span>
          </section>
          <section className="mobile-filters-body">
            <SimpleFilter
              Name={translateText("status")}
              Id="status"
              ChangeHandler={() => selectStatus()}
              Options={props.StatusOptions}
            />
            <SimpleFilter
              Name={translateText("location")}
              Id="location"
              ChangeHandler={() => selectLocations()}
              IsWithId
              Options={Locations}
            />
            <SearchSelect
              Label={translateText("required_skills")}
              SearchLabel={translateText("search_skills")}
              ToggleSearch={(NameLike) => fetchSkills(NameLike)}
              Options={Skills}
              SelectedItems={SelectedSkills}
              UpdateList={(SelectedList) => updateSkills(SelectedList)}
              ClearInput={() => clearSkills()}
              LangData={props.LangData}
              RemoveSelectedState={() => removeSkillsSelectedState()}
            />
          </section>
          <section className="mobile-filters-footer">
            <div onClick={() => applyMobileFilters()}>
              {translateText("apply_filters")}
            </div>
          </section>
        </div>
      ) : null}
      <h1 className="section-name">{translateText("current_activities")}</h1>
      <section className="datepicker-holder">
        <section className="datepicker-content">
          <i
            className="feather-calendar"
            onClick={() => displayDatepicker()}
          ></i>
          {SelectedDate === undefined ? (
            <p className="displayed-date" onClick={() => displayDatepicker()}>
              {translateText("date_from_to")}
            </p>
          ) : (
            <p
              className="displayed-date"
              id="displayed-date"
              onClick={() => displayDatepicker()}
            >
              {SelectedDate.start + " - " + SelectedDate.end}
            </p>
          )}
          <i
            id="datepicker-trigger"
            className="feather-chevron-down"
            onClick={() => displayDatepicker()}
          ></i>
          <div className={DatepickerIsOpen ? "datepicker-shown" : "hidden"}>
            <RangeDatepicker
              SaveSelectedDate={(Start, End) => saveSelectedDate(Start, End)}
              Apply={(DateIsReset) => displayDatepicker(DateIsReset)}
              Close={() => displayDatepicker()}
              LangData={props.LangData}
              DatePickerIsOpen={DatepickerIsOpen}
            />
          </div>
        </section>
      </section>
      {window.innerWidth <= 450 ? (
        <div className="is-mobile mobile-filters">
          <SearchInput
            OnChange={() => handleSearchbyTitle()}
            Placeholder={translateText("activity_title") + " ..."}
          />
        </div>
      ) : null}
      {window.innerWidth > 450 ? (
        <div className="filters-holder is-desktop">
          <h2>{translateText("filters")}</h2>
          <section className="filters">
            <SearchInput
              OnChange={() => handleSearchbyTitle()}
              Placeholder={translateText("activity_title") + " ..."}
            />
            <SimpleFilter
              Name={translateText("status")}
              Id="status"
              ChangeHandler={() => selectStatus()}
              Options={props.StatusOptions}
            />
            <SimpleFilter
              Name={translateText("location")}
              Id="location"
              ChangeHandler={() => selectLocations()}
              IsWithId
              Options={Locations}
            />
            <SearchSelect
              Label={translateText("required_skills")}
              SearchLabel={translateText("search_skills")}
              ToggleSearch={(NameLike) => fetchSkills(NameLike)}
              Options={Skills}
              SelectedItems={SelectedSkills}
              UpdateList={(SelectedList) => updateSkills(SelectedList)}
              ClearInput={() => clearSkills()}
              RemoveSelectedState={() => removeSkillsSelectedState()}
              LangData={props.LangData}
            />
          </section>
        </div>
      ) : null}
      <div className="saved-only">
        <img alt="" src={BookmarkIcon} />
        <p>{translateText("saved_items_only")}</p>
        <Switch ChangeEvent={() => props.DisplaySavedItems()} Id="saved" />
        <section
          onClick={() => displayMobileFilters()}
          className="mobile-filters is-mobile"
        >
          <i className="feather-filter"></i>
          <p>{translateText("filters")}</p>
          {SelectedFilterCount === 0 ? null : (
            <p className="active-filters-count">
              {"( " + SelectedFilterCount + " " + "active" + " )"}
            </p>
          )}
        </section>
      </div>
    </div>
  );
};

export default ContentHead;
